import queryString from 'query-string';
import { uploadFiles, get, del } from './apiUtils';

const defaultUrl = '/CompaniesDocuments/';
const upload = '/OrderFile/';

export default {
  uploadCompanyOrderDocument: ({ CompanyId, data }) => uploadFiles(`${defaultUrl}${CompanyId}${upload}`, data),
};
